export function getKeyByValue(object: any, value: any) {
	return Object.keys(object).find((key) => object[key] === value);
}

export function roundingUpPrice(price: number, number?: number) {
	return parseFloat(price.toFixed(number || 4));
}
